import React from 'react'
import { useContext, useState, useRef, useEffect } from 'react';
import { RemoveLocalStorage } from './LocalStorage/LocalStorage';
import { ContextProvider } from './Context';
import { HandleUserSession } from './ApiCollection.jsx/ApiBuck';
export const ActivityWrapper = ({children}) => {
  const {sessionExpiration, setSessionExpiration} = useContext(ContextProvider)
      const [sec, setSec] = useState(0);
  // The aim is to create three different situation when the user will
  // will be logged from the page
  // 1. The point in which the authToken is not gotten through cookies after a request from
  // an expitred token.The usage of user session expiration component must be 
  //used here.
  // 2. No user activity was detected within 20 minutes, a pop up for inactivity is created.
  // 3. The user enters the dashboard or any protected-route through an openend tab
  // for the opened tab a cookie present in the frontend is to check the time when it was created,
  // then does it substraction to know if expired or not.
  //4. The authorisedLogin, getToken and userStatus is not found in the local Storage.
  
  const TrackSessionExpiration = ()=> {
    const expiryTime = localStorage.getItem("SessionExpiration");
  const getDifferenceForExpiration = Date.now()  > Number(expiryTime);
  //Checking for the last 30 seconds difference between the expiryTime and the current Time,
  const HandleUserSessionPopUpTime = Number(expiryTime) - Date.now() <= 35000;
  if(HandleUserSessionPopUpTime && sessionExpiration === false 
    && Number(expiryTime) - Date.now() > 5000 && Number(expiryTime) - Date.now() < 35000
  ){
    setSessionExpiration(true);
    //An extra 5 seconds is set for the sessionModal to get running
 setSec(30);
  }
   return getDifferenceForExpiration;
  }  
   
    const SessionIntervalHold = useRef(null)
  
  const isLogoutInteraction = (eventTarget)=> {
    if(!eventTarget || typeof eventTarget.closest !== "function") return false;
    const interactiveElement = eventTarget.closest('button, a, [role="button"]');
    if(!interactiveElement) return false;

    const label = (interactiveElement.textContent || interactiveElement.getAttribute("aria-label") || "")
      .trim()
      .toLowerCase();
    const href = (interactiveElement.getAttribute("href") || "").toLowerCase();

    return label === "logout" || href === "/login";
  };

  //Resets the timer on user activity using the event click as an example 
  function ResetTimer(e){
      if(!localStorage.getItem("cxccxfd")) return;
      if(!isLogoutInteraction(e?.target)
      && TrackSessionExpiration() === false
       && sessionExpiration=== false){
      const Reset = 800  *  1000;
      const resetExpiration = Date.now() + Reset;
  return localStorage.setItem("SessionExpiration", resetExpiration);
   }
  }

  useEffect(()=> {
    const handleActivity = (event)=> {
      ResetTimer(event);
    };

    const handleVisibilityChange = ()=> {
      if(document.visibilityState === "visible"){
        ResetTimer();
      }
    };

    window.addEventListener("click", handleActivity);
    window.addEventListener("load", handleActivity);
    window.addEventListener("keyup", handleActivity);
    window.addEventListener("keydown", handleActivity);
    window.addEventListener("touchstart", handleActivity, { passive: true });
    window.addEventListener("touchmove", handleActivity, { passive: true });
    window.addEventListener("pointerdown", handleActivity, { passive: true });
    window.addEventListener("pointermove", handleActivity, { passive: true });
    window.addEventListener("scroll", handleActivity, { passive: true });
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return ()=> {
      window.removeEventListener("click", handleActivity);
      window.removeEventListener("load", handleActivity);
      window.removeEventListener("keyup", handleActivity);
      window.removeEventListener("keydown", handleActivity);
      window.removeEventListener("touchstart", handleActivity);
      window.removeEventListener("touchmove", handleActivity);
      window.removeEventListener("pointerdown", handleActivity);
      window.removeEventListener("pointermove", handleActivity);
      window.removeEventListener("scroll", handleActivity);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [sessionExpiration]);
 
  
  useEffect (()=> { 
  const checkForIntervalCallBack = ()=> {
   const sessionExpirationValue = TrackSessionExpiration();
      const clearSessionExpirationMemory = ()=> {
            window.location.href="/Login"  
          return RemoveLocalStorage();
      }
      if(sessionExpirationValue === true && sec === 0 ){
      clearInterval(SessionIntervalHold.current);
      return clearSessionExpirationMemory() 
      }
    }
   checkForIntervalCallBack();
      SessionIntervalHold.current =  setInterval(checkForIntervalCallBack, 30000);
    return ()=> {
      clearInterval(SessionIntervalHold.current);
     }
        // eslint-disable-next-line
  }, [])
  
  return (
    <div className="flex flex-col w-full items-center">
      {children}
      {sessionExpiration && <HandleUserSession sec={sec} setSec={setSec}/>}
    </div>
  )
}

